import { ActionFactory } from "./../actions/ActionFactory.js";
import { Links, Type, DataTypes } from "generated";
import { Converter } from "./converter.js";
import { TaskManager } from "./../screentask/TaskManager.js";
import { Constants as C, methods as M } from "./methods.js";
import { toBool, convertPropertyPath, convertToTypesForCompare } from "../lib/utils.js";
import i18next from "i18next";
/**
 * @class ItemSubscription
 * @classdesc Обработчик связей в проекте
 */
export class ItemSubscription {
    constructor(serverAdapterInstance) {
        this.SubPack = {
            items: [],
        };
        this.ackSequenceNumber = 0;
        this.sendTimestamp = 0;
        this.Links = new Links();
        this.WinDefs = window._windefs;
        this.Type = new Type();
        this.Observer = new Map();
        this.observerIndex = 1;
        this.ServerParam = {};
        this.ItemsContainer = new Map();
        this.location = window._globalParams.location;
        this.ServerAdapter = serverAdapterInstance;
        this.ServerAdapter.reSubscribe = this.reSubscribe.bind(this);
        this.clientGlobalParamIndex = 0;
        this.clientGlobalParamCallBacks = new Map();
        this.clientGlobalParamValues = new Map();
        this.started = false;
        this.pendingCallPous = new Map();
    }

    async AddWindows(wins) {
        let allItems = [];
        this.SubPack.subscriptionId = this.ServerAdapter.subscriptionId;

        if (this.TaskManager?.hasTasks) {
            this.TaskManager.getTask().worker.postMessage({
                isNewWindow: true,
            });
        }

        for (let i = 0; i < wins.length; i++) {
            const winItem = wins[i];
            const msWin = winItem.window;
            const id = msWin.id;
            const typeId = msWin.typeid;
            let items = [];
            const links = this.Links.windows[id];
            let subLinks;
            if (id != typeId) {
                subLinks = this.Links.windows[typeId];
            }

            if (subLinks && subLinks.length > 0) {
                var items2 = this._LinkCreator(subLinks, msWin);
            }
            const items1 = this._LinkCreator(links, msWin);

            if (items1 && items1.length > 0) {
                items = items.concat(items1);
            }
            if (items2 && items2.length > 0) {
                items = items.concat(items2);
            }

            if (items.length > 0) {
                allItems = allItems.concat(items);
            }
        }

        for (let i = 0; i < wins.length; i++) {
            const winItem = wins[i];
            const msWin = winItem.window;

            if ($pm.hasPermissions && window.__rootWin != msWin) {
                $pm.controlEnable(msWin.childNodes);
            }
            if (winItem.window.afterInitialize && 
                  (!winItem.window.canCallAfterInitialize || winItem.window.canCallAfterInitialize()))
                winItem.window.afterInitialize();
        } 

        if (this.SubPack.subscriptionId) {
            if (allItems.length > 1000) {
                let promises = [];
                for (let i = 0; i <= (allItems.length - 1) / 1000; i++) {
                    let end =
                        (i + 1) * 1000 < allItems.length
                            ? (i + 1) * 1000
                            : allItems.length;
                    promises.push(
                        this.CreateMonitoredDataItems(
                            allItems.slice(i * 1000, end)
                        )
                    );
                }
                return Promise.all(promises).then(() => this.StartWatch());
            } else if (allItems.length > 0) {
                this.CreateMonitoredDataItems(allItems).then(() =>
                    this.StartWatch()
                );
            } else {
                this.StartWatch();
            }
        }
    }

    CreateTaskManager() {
        if (!this.TaskManager) {
            this.TaskManager = new TaskManager();
            window.$TaskManager = this.TaskManager;
            if (this.TaskManager.hasTasks) {
                this.TaskManager.start();
            }
        }
    }

    RemoveWindow(winItem) {
        const msWin = winItem.window;
        const id = msWin.id;
        const typeId = msWin.typeid;
        const links = this.Links.windows[id];

        const subLinks = id != typeId ? this.Links.windows[typeId] : null;

        if (!links && !subLinks) {
            return;
        }
        this._LinkDestructor(links, msWin);
        if (subLinks && subLinks.length > 0) {
            this._LinkDestructor(subLinks, msWin);
        }

        delete msWin.windowTriggers;
        delete msWin.eventListener;
    }

    async AddWindow(winItem) {
        const msWin = winItem.window;
        if ($pm.hasPermissions) {
            $pm.controlEnable(msWin.childNodes);
        }

        const id = msWin.id;
        const typeId = msWin.typeid;
        const links = this.Links.windows[id];
        if (id != typeId) {
            var subLinks = this.Links.windows[typeId];
        }

        if (this.TaskManager?.hasTasks) {
            this.TaskManager.getTask().worker.postMessage({
                isNewWindow: true,
            });
        }

        if (!links && !subLinks) {
            return;
        }

        this.SubPack.subscriptionId = this.ServerAdapter.subscriptionId;

        if (subLinks && subLinks.length > 0) {
            var items2 = this._LinkCreator(subLinks, msWin);
        }
        const items1 = this._LinkCreator(links, msWin);

        let items;
        if (items2 && items2.length > 0) {
            items = items1.concat(items2);
        } else {
            items = items1;
        }
        this.CreateMonitoredDataItems(items);
        if (msWin.afterInitialize) msWin.afterInitialize();
    }

    RunScreenTask() {
        this.CreateTaskManager();
        if (this.Links.windows[0]) {
            this.SubPack.subscriptionId = this.ServerAdapter.subscriptionId;
            const ScreenTaskItems = this._LinkCreator(
                this.Links.windows[0],
                window.__rootWin
            );
            this.CreateMonitoredDataItems(ScreenTaskItems);
        }
    }

    async DeleteMonitoredDataItems(items) {
        const subPack = {
            items: Array.isArray(items) ? items : [items],
            subscriptionId: this.ServerAdapter.subscriptionId,
        };

        let options = {
            methodType: C.single,
            method: M.DeleteMonitoredDataItems,
            pack: subPack,
        };
        return await new Promise(resolve => {
            this.ServerAdapter.sendRequest(options, data => resolve(data));
        });
    }

    async CreateMonitoredDataItems(items, subsId) {
        if (items.length > 0) {
            this.SubPack.items = items;
            this.SubPack.subscriptionId = subsId || this.SubPack.subscriptionId;
            let options = {
                pack: this.SubPack,
                method: M.CreateMonitoredDataItems,
                methodType: C.single,
            };
            items.forEach(item =>
                this.ItemsContainer.set(item.clientHandle, item)
            );
            return await new Promise(resolve => {
                this.ServerAdapter.sendRequest(options, data => {
                    if (data.items) {
                        let errors = [];

                        data.items.forEach((el, i) => {
                            if (
                                el.statusCode === 0 &&
                                this.Observer.has(el.clientHandle)
                            ) {
                                this.Observer.get(el.clientHandle).monitoredItemId = el.monitoredItemId;
                            }

                            if (el.statusCode === 0x801F0000) {
                                const { itemId, path } = items[i];
                                errors.push(`${itemId}${path ? `/${path}` : ""}`);
                            }
                        });

                        if (errors.length) {
                            $ns.add({
                                type: "error",
                                time: new Date().toLocaleString(),
                                title: i18next.t("unable_to_subscribe_to_parameter"),
                                text: String.format(i18next.t("subscription_error"), errors.map(x => `id ${x}`).join(", ")),
                            });
                        }
                    }
                    resolve(data);
                });
            });
        }
    }

    async CreateDataSubscription() {
        const pack = {
            requestedPublishingInterval: 100,
            requestedLifetimeInterval: 120000,
            maxNotificationsPerPublish: 0,
            maxSize: 1000,
        };
        let options = {
            method: M.CreateDataSubscription,
            methodType: C.single,
            pack,
        };
        return await new Promise(resolve => {
            this.ServerAdapter.sendRequest(options, data => {
                this.ServerAdapter.subscriptionId = data.subscriptionId;
                resolve(data);
            });
        });
    }

    GetInstanceFields(action) {
        let objectid = action.ObjectId
            ? action.ObjectId
            : this._getParentParam(action.context, "objectid");
        let taskid =
            Number(action.TaskId) != -1 && typeof action.TaskId != "undefined"
                ? action.TaskId
                : this._getParentParam(action.context, "taskid");
        let outerpath =
            action.FullOuterPath != null
                ? action.FullOuterPath
                : action.OuterPath === "/" ? "" : this._getOuterPath(action.context, action.OuterPath) + (action.OuterPath || "");

        return { objectid, taskid, outerpath };
    }

    isTyped(element) {
        let result =
            (typeof element.typed !== "undefined" && !!element.typed) ||
            (element.getAttribute &&
                element.getAttribute("typed") === "true") ||
            (element.nodeName === "MS-SVG" &&  //TODO Уже лишнее
                element.getAttribute("outerpath") !== null);

        return result;
    }

    _getParentParam(msWin, param, findUntyped) {
        let w = msWin;
        let retVal = null,
            retValUntyped = null;
        param = param || param.toLowerCase();
        while (w && w.getAttribute && (retVal == null || Number(retVal) === 0)) {
            if (this.isTyped(w)) {
                //while (w.parentNode && this.isTyped(w.parentNode)) {
                //    w = w.parentNode;
                //}
                retVal = w.getAttribute(param);
            } else if (
                findUntyped &&
                (retValUntyped == null || Number(retValUntyped) === 0)
            )
                retValUntyped = w.getAttribute(param);
            w = w.parentNode;
        }
        if (findUntyped && (retVal == null || Number(retVal) === 0))
            return Number(retValUntyped);
        else return Number(retVal);
    }

    _getOuterPath(msWin, actionOuterPath) {
        let w = msWin;
        let retVal = [];
        let objectId = 0;
        let isFirst = true;
        while (w && w.getAttribute && !objectId) {
            if (this.isTyped(w)) {
                do {
                    let path = w.getAttribute("outerpath");
                    objectId = +w.getAttribute("objectid");
                    if (path !== null && typeof path !== "undefined") {
                        if (!isFirst || path !== actionOuterPath) //Для действий может совпадать с OuterPath контрола
                            retVal.push(path);
                        isFirst = false;
                    }
                    w = w.parentNode;
                } while (w && this.isTyped(w) && !objectId);
            }
            w = w?.parentNode;
        }
        return retVal.reduceRight((acc, cur) => acc + cur, "");
    }

    _LinkDestructor(links, msWin) {
        if (!links) {
            return [];
        }
        for (let index = 0; index < links.length; index++) {
            const el = links[index];
            switch (el.Source.Type) {
                case "server":
                    const sourceId = el.Source.ItemId == "0"
                            ? this._getParentParam(msWin, "objectid")
                            : Number(el.Source.ItemId);
                    const items =
                        this.Links.Items[sourceId + "/" + el.Source.DataType] ||
                        this.Links.Items[sourceId + "/" + el.Source.DataType + "/" + el.Source.PropertyPath];
                    if (items) {
                        items.server.Targets.forEach(win => {
                            if (win.el == msWin) {
                                delete win.el;
                            } else if (win.el && !win.el.isConnected) {
                                win.el = null;
                                delete win.el;
                            } else {
                                for (let index = 0; index < msWin.childNodes.length; index++) {
                                    const element = msWin.childNodes[index];
                                    if (win.el == element) {
                                        delete win.el;
                                    }
                                }
                            }
                        });
                    }
                    break;
                case "clientglobal":
                    const path = el.Source.PropertyPath;
                    const winlinks = this.clientGlobalParamCallBacks.get(path);
                    if (winlinks && winlinks.has(msWin.clientGlobalParamIndex)) {
                        winlinks.delete(msWin.clientGlobalParamIndex);                        
                    }        
                    break;
                default:
                    break;
            }
        }
    }

    updateItemId(msWin, element) {
        if (element.ItemId == "0") {
            element.ItemId = this._getParentParam(msWin, "objectid");
            if (element.TaskNumber == -1) {
                element.TaskNumber = this._getParentParam(msWin, "taskid");
                element.PropertyPath = this._getOuterPath(msWin) + element.PropertyPath;
            }
        }
    }

    updateEl(msWin, node, element) {      
        if (element.ItemId == msWin.typeid) {
            element.el = msWin;
            return;
        }
        const linkEl = this.getEl(msWin, node, element.ItemId, element.Type);
        if (linkEl) {
            element.el = linkEl;
        } 
    }

    /**
     * Создание связей при инициализации
     * @param {array} Links массив связей текущего окна
     * @param {HTMLElement} msWin текущее окно
     * @return {array} параметры сервера, на которые нужно подписаться
     */
    _LinkCreator(links, msWin, node) {
        if (!links || !msWin) {
            return [];
        }
        const upLinks = [];
        const resultItems = [];
        
        if (!msWin.clientGlobalParamIndex)
            msWin.clientGlobalParamIndex = ++this.clientGlobalParamIndex;

        for (let index = 0; index < links.length; index++) {
            let el = JSON.parse(JSON.stringify(links[index]));
            try {
                switch (el.Source.Type) {
                    case "server":
                        el.Source.ItemId = el.Source.ItemId == "0"
                                ? this._getParentParam(msWin, "objectid")
                            : Number(el.Source.ItemId);

                        let elIds = $pr.objInsMap[el.Source.ItemId] ?? [ el.Source.ItemId ];
                        elIds.forEach(elId => {
                            const elSource = elIds.length > 1 ? { ...el.Source } : el.Source;
                            elSource.ItemId = elId;
                            const sourceId = elSource.ItemId;

                            elSource.TaskNumber = elSource.TaskNumber == "-1"
                                ? this._getParentParam(msWin, "taskid")
                                : Number(elSource.TaskNumber);
                            const taskId = elSource.TaskNumber;

                            let basePropPath = elSource.PropertyPath;
                            elSource.PropertyPath = this._getOuterPath(msWin) + basePropPath;

                            const sId = elSource.PropertyPath
                                ? sourceId + "/" + elSource.DataType + "/" + elSource.PropertyPath
                                : sourceId + "/" + elSource.DataType;
                            const needSValue = el.Targets.some(
                                (t) => t.Type === "action" || t.Type === "trigger"
                            );
                            let sValue;
                            if (needSValue) {
                                if (this.ServerParam[sId])
                                    sValue = this.ServerParam[sId].value;
                                else
                                    sValue = this._convert(elSource, elSource.DefaultValue, elSource.DataType, elSource.ItemId);
                            }

                            const items =
                                this.Links.Items[sourceId + "/" + elSource.DataType] ||
                                this.Links.Items[sourceId + "/" + elSource.DataType + "/" + elSource.PropertyPath];
                            if (items) {
                                el.Targets.forEach(target => {
                                    this.updateEl(msWin, node, target);
                                });

                                if (items.server.Source) {
                                    items.server.Source.UseCount = (items.server.Source.UseCount ?? 0) + 1;
                                    el.Targets.forEach(target => {
                                        if (items.server.Source.value !== undefined) {
                                            // установка значения по умолчанию
                                            // на линках внутри клиента
                                            if (target.Type === "client" || target.Type === "trend") {
                                                upLinks.push({
                                                    type: elSource.Type,
                                                    target: target,
                                                    value: items.server.Source.value,
                                                    datatype: elSource.DataType,
                                                    sourceId: elSource.ItemId,
                                                });
                                            }
                                        }
                                        if (target.Type === "action") {
                                            const control = this.SetAction(target, msWin, node);
                                            if (!control.actions[target.ActionId]) {
                                                const act = JSON.parse(JSON.stringify(this.Type.type[target.ItemId].actions[target.ActionId]));
                                                control.actions[target.ActionId] = new ActionFactory(act, control);
                                            }

                                            this.UpdateAction(control, target, this._convert(target, sValue, elSource.DataType, elSource.ItemId));
                                        }
                                        if (target.Type === "trigger") {
                                            target.el = msWin;
                                            this.setTrigger(target, sValue, elSource.DataType, elSource.DataType !== "STRING");
                                            // this.setTrigger(msWin, target, items.server.Source.value, elSource.DataType);
                                        }
                                        if (target.Type === "trend" && target.PropertyPath.indexOf("DataSource") !== -1) {
                                            if (target.Convertations && target.el.convertation) {
                                                target.el.convertation[`${sourceId}/${elSource.PropertyPath}`] = {
                                                    Convertations: target.Convertations,
                                                    itemId: sourceId,
                                                    path: elSource.PropertyPath,
                                                    type: elSource.DataType,
                                                }
                                            }
                                            if (!Array.isArray(items.server.Source.value)) {
                                                target.el.addDataSource(
                                                    {
                                                        taskId: elSource.TaskNumber || 0,
                                                        itemId: Number(elSource.ItemId),
                                                        path: elSource.PropertyPath,
                                                        type: elSource.DataType,
                                                        dataSourceId: "MPLCDataSource",
                                                        usesCounts: 1,
                                                    },
                                                    target.PropertyPath,
                                                    true
                                                );
                                                if (items.server.Source.DataType === "STRING") {
                                                    const i = +target.PropertyPath.split(".")[1];
                                                    target.el.addCacheStringPenPath(i, items.server.Source.value)
                                                }
                                            } else {
                                                target.el.onStringPenChanged(target.PropertyPath, items.server.Source.value);
                                            }
                                        }
                                    });
                                }

                                const els = items.server.Targets.filter(t => typeof t.el !== "undefined" || (t.Type !== "client" && t.Type !== "trigger"));

                                items.server.Targets = el.Targets.concat(els);
                            } else {
                                el.Targets.forEach(target => {
                                    this.updateEl(msWin, node, target);
                                    if (target.Type === "action") {
                                        const control = this.SetAction(target, msWin, node);
                                        if (!control.actions[target.ActionId]) {
                                            this.createAction(control, target.ActionId);
                                        }

                                        this.UpdateAction(control, target, this._convert(target, sValue, elSource.DataType, elSource.ItemId));
                                    }
                                    if (target.Type === "trigger") {
                                        target.el = msWin;
                                    } else if (target.Type === "trend" && target.PropertyPath.indexOf("DataSource") !== -1) {
                                        if (target.Convertations && target.el.convertation) {
                                            target.el.convertation[`${sourceId}/${elSource.PropertyPath}`] = {
                                                Convertations: target.Convertations,
                                                itemId: sourceId,
                                                path: elSource.PropertyPath,
                                                type: elSource.DataType,
                                            }
                                        }

                                        target.el.addDataSource(
                                            {
                                                taskId: taskId || 0,
                                                itemId: sourceId,
                                                path: elSource.PropertyPath,
                                                type: elSource.DataType,
                                                dataSourceId: "MPLCDataSource",
                                                usesCounts: 1,
                                            },
                                            target.PropertyPath,
                                            true
                                        );
                                    }
                                });

                                const linkKey = `${sourceId}/${elSource.DataType}${elSource.PropertyPath ? "/" + elSource.PropertyPath : ""}`;

                                if (this.Links.Items[linkKey]) {
                                    let targets = this.Links.Items[linkKey].server.Targets;
                                    this.Links.Items[linkKey].server.Targets = el.Targets.concat(targets);
                                } else {
                                    this.Links.Items[linkKey] = { server: el };
                                }

                                elSource.UseCount = 1;
                                elSource.ObserverIndex = this.observerIndex;
                                elSource.LinkKey = linkKey;
                                this.Observer.set(this.observerIndex, elSource);

                                resultItems.push({
                                    taskId: taskId || 0,
                                    itemId: Number(sourceId),
                                    path: elSource.PropertyPath,
                                    type: elSource.DataType,
                                    dataSourceId: "MPLCDataSource",
                                    clientHandle: this.observerIndex,
                                    usesCounts: 1,
                                });
                                this.observerIndex++;
                            }
                        });
                        break;
                    case "clientglobal":
                        let targets = el.Targets;
                        let newtargets = [];
                        targets.forEach(target => {
                            let targetId = target.ItemId;
                            if (target.Type === "server" && $pr.objInsMap[targetId]) {
                                $pr.objInsMap[targetId].forEach(elId => {
                                    let newtarget = { ...target };
                                    newtarget.ItemId = elId;
                                    newtarget.TaskNumber = newtarget.TaskNumber == "-1"
                                        ? this._getParentParam(msWin, "taskid")
                                        : Number(newtarget.TaskNumber);
                                    newtargets.push(newtarget);
                                });
                            }
                            else {
                                if (target.ItemId != "0") {
                                    if (target.Type === "trigger")
                                        target.el = msWin;
                                    else
                                        this.updateEl(msWin, node, target);
                                }
                                newtargets.push(target);
                            }
                        });
                        el.Targets = newtargets;
                    


                        const winIndex = msWin.clientGlobalParamIndex;
                        const path = el.Source.PropertyPath;
                        const callback = this.LinkUp.bind(this, null, el);                    
                        if (!this.clientGlobalParamCallBacks.has(path)) {
                            this.clientGlobalParamCallBacks.set(path, new Map());                        
                        }                   
                        let winlinks = this.clientGlobalParamCallBacks.get(path);
                        if (!winlinks.has(winIndex)) {
                            winlinks.set(winIndex, []);
                        }
                        let callbacks = winlinks.get(winIndex);
                        callbacks.push(callback);
                            
                        let val;
                        if (!this.clientGlobalParamValues.has(path)) {
                            val = el.Source.DefaultValue;
                            if (val !== undefined) {
                                this.clientGlobalParamValues.set(path, val);
                            }
                        }
                        else
                            val = this.clientGlobalParamValues.get(path);
                        if (val !== undefined) {
                            callback(val, null, null, null, false, false);
                        }
                        
                        break;
                    case "client":
                        // let key;
                        let sourceEl;
                        
                        if (msWin.typeid == el.Source.ItemId) {
                            // key = msWin.id;
                            el.Source.el = msWin;
                            //const elSourcePath = el.Source.PropertyPath.toLowerCase();
                            //if (typeof el.Source.el[elSourcePath] === "undefined" &&
                            //    el.Source.el.getAttribute(elSourcePath) === null &&
                            //    el.Source.PropertyPath.indexOf(".") < 0) {
                            //    const v = Converter._convert(el.Source.DefaultValue, el.Source.DataType);
                            //    el.Source.el[elSourcePath] = v;
                            //}
                            sourceEl = msWin;
                        } else {
                            // key = msWin.id + '/' + el.Source.ItemId;
                            sourceEl = this.getEl(msWin, node, el.Source.ItemId, el.Source.Type);
                            if (sourceEl) {
                                sourceEl.pId = msWin.id;
                                sourceEl.msWin = msWin;
                            }
                            else
                                break;
                        }

                        el.Targets.forEach(target => {
                            this.updateItemId(msWin, target);
                            this.updateEl(msWin, node, target);
                            if (target.Type === "trend" && target.PropertyPath.indexOf("DataSource") !== -1 && el.Source.DataType === "STRING") {
                                //стринговое перо, клиентский параметр
                                target.el.addDataSource(
                                    {
                                        taskId: el.Source.TaskNumber || 0,
                                        itemId: el.Source.ItemId,
                                        path: el.Source.PropertyPath,
                                        type: el.Source.DataType,
                                        dataSourceId: "MPLCDataSource",
                                        usesCounts: 1,
                                    },
                                    target.PropertyPath
                                );
                            }                        
                        });
                        
                        const pathpnt = el.Source.PropertyPath.split(".");
                        if (pathpnt.length > 1) {
                            el.Targets.forEach(target => {
                                target.SourcePath = el.Source.PropertyPath;
                            });
                        }
                        const propertyPath = pathpnt[0].toLowerCase();

                        if (el.Source.PropertyPath == "PanelDataSource") {
                            let realSourceDataType = el.Targets[0].DataType;
                            if (sourceEl && typeof sourceEl.setPdsType === "function") {
                                sourceEl.setPdsType(realSourceDataType);
                            }
                        }
                        if (sourceEl.Links[propertyPath]) {
                            if (sourceEl.Links[propertyPath].Source.DataType !== el.Source.DataType) {
                                for (const iterator of el.Targets) {
                                    iterator.SourceDataType = el.Source.DataType;
                                }
                            }
                            sourceEl.Links[propertyPath].Targets = sourceEl.Links[propertyPath].Targets.concat(el.Targets);
                        } else {
                            sourceEl.Links[propertyPath] = el;
                        }
                        if (sourceEl && sourceEl.AddLinkCallback) {
                            sourceEl.AddLinkCallback(propertyPath, this.LinkUp.bind(this));
                            let srcVal = sourceEl[propertyPath] ?? sourceEl.getAttribute(propertyPath);
                            if (pathpnt.length > 1) {
                                for (let i = 1; i < pathpnt.length; i++) {
                                    if (srcVal === undefined) {
                                        $ns.add({
                                            type: "error",
                                            time: new Date().toLocaleString(),
                                            title: i18next.t("title_parametr_error"),
                                            text: String.format(i18next.t("cannot_get_parametr"), el.Source.ItemId, el.Source.PropertyPath , el._elname ?? ""),
                                        });
                                        break;
                                    }

                                    let v;
                                    if (typeof srcVal === "string") {
                                        try {
                                            srcVal = JSON.parse(srcVal);
                                        } catch (e) {
                                        }

                                        v = srcVal[pathpnt[i]];
                                    }

                                    if (v != null) {
                                        srcVal = v;
                                    } else if (srcVal !== null) {
                                        srcVal = typeof srcVal[pathpnt[i]] === "undefined"
                                            ? srcVal[pathpnt[i].toLowerCase()]
                                            : srcVal[pathpnt[i]];
                                    }
                                }
                            }
                            el.Targets.forEach(target => {
                                // установка значения по умолчанию
                                // на линках внутри клиента
                                if (target.Type === "client" && typeof srcVal !== "undefined" && srcVal !== null) {
                                    upLinks.push({
                                        type: el.Source.Type,
                                        sourceP: el.Source.PropertyPath,
                                        target: target,
                                        value: srcVal,
                                        datatype: el.Source.DataType,
                                        sourceId: el.Source.ItemId,
                                    });
                                } else if (target.Type === "svg" && typeof srcVal !== "undefined") {
                                    if (el.Source.ItemId == target.ItemId && target.el.setSvgParams) {
                                        target.el.setSvgParams(target.PropertyPath, srcVal);
                                    } else {
                                        const pp = target.PropertyPath.split(":");
                                        if (pp.length > 1) {
                                            const pr =
                                                pp[0] === "svg"
                                                    ? [...pp, el.Source.PropertyPath].slice(1)
                                                    : pp.slice(1);
                                            target.el[pp[0].toLowerCase()](pr, this._convert(target, srcVal, el.Source.DataType, el.Source.ItemId));
                                        }
                                    }
                                } else if (target.Type === "action" && typeof srcVal !== "undefined" && srcVal !== null) {
                                    if (!target.el.actions[target.ActionId]) {
                                        this.createAction(target.el, target.ActionId);
                                    }
                                    // target.el.actions[target.ActionId][target.PropertyPath] = srcVal;
                                    this.UpdateAction(target.el, target, this._convert(target, srcVal, el.Source.DataType, el.Source.ItemId));
                                } else if (target.Type == "trigger") {
                                    target.el = msWin;
                                    this.setTrigger(target, el.Source.DefaultValue, el.Source.DataType, false);
                                }
                            });
                            if (srcVal === undefined && typeof el.Source.DefaultValue !== "undefined" && el.Targets[0].Type !== "server") {
                                upLinks.push({
                                    type: el.Source.Type,
                                    sourceP: el.Source.PropertyPath,
                                    target: el.Source,
                                    value: el.Source.DefaultValue,
                                    datatype: el.Source.DataType,
                                    sourceId: el.Source.ItemId,
                                });
                            }
                        }
                        break;
                    case "action":
                        const control = this.SetAction(el.Source, msWin, node);
                        el.Targets.forEach(target => {
                            this.updateItemId(msWin, target);
                            this.updateEl(msWin, node, target);
                        });

                        if (control.actions[el.Source.ActionId].operation) {
                            el.Targets[0].Operation = control.actions[el.Source.ActionId].operation;
                        }
                        control.actions[el.Source.ActionId].AddLinkCallback(el.Source.PropertyPath, this.LinkUp.bind(this, control, el));

                        // control.msWin = msWin;
                        break;
                    case "screentask":
                        //fix: надо проверить и привести к новой модели

                        this.CreateTaskManager();
                        el.Targets.forEach(target => {
                            this.updateEl(msWin, node, target);
                            if (target.Type == "action") {
                                const control = this.SetAction(target, msWin, node);
                                if (!control.actions[target.ActionId]) {
                                    this.createAction(control, target.ActionId);
                                }
                                const sValue = this.TaskManager.tasks.generatedTask.getValue(el.Source) || el.Source.DefaultValue;
                                this.UpdateAction(control, target, this._convert(target, sValue, el.Source.DataType, el.Source.ItemId));
                            } else if (target.Type === "trigger") {
                                target.el = msWin;
                            } else {
                                const sValue = this.TaskManager.tasks.generatedTask.getValue(el.Source);
                                if (sValue !== undefined && target.Type !== "server") {
                                    const c = this._convert(target, sValue, el.Source.DataType, target.ItemId);
                                    upLinks.push({
                                        type: el.Source.Type,
                                        target: target,
                                        value: c,
                                        datatype: target.DataType,
                                        sourceId: target.ItemId,
                                    });
                                }
                            }
                        });
                        el.screentask = true;
                        el.msWin = msWin;
                        this.TaskManager.tasks.generatedTask.AddLinkCallback(el.Source.PropertyPath, this.LinkUp.bind(this, null, el));
                        break;
                    case "reference":
                        el.Targets.forEach(target => {
                            const linkEl = this.getEl(msWin, node, target.ItemId, target.Type);
                            linkEl[target.PropertyPath.toLowerCase()] = el.Source.DefaultValue;
                        });
                        break;
                    case "trend":
                        break;
                    case "object":
                    case "template":                    
                        el.Targets.forEach(target => {
                            this.updateItemId(msWin, target);
                            this.updateEl(msWin, node, target);
                            if (target.el) {
                                if (target.el[target.PropertyPath.toLowerCase()] !== el.Source.DefaultValue) {
                                    target.el[target.PropertyPath.toLowerCase()] = el.Source.DefaultValue;
                                }
                            }
                        });                    
                        break;
                    default:
                        console.log(`Неизвестный тип связи: ${el.Source.Type}`);
                        break;
                }
            } catch (e) {
                console.error(e);
                $ns.add({
                    type: "error",
                    time: new Date().toLocaleString(),
                    title: i18next.t("title_error_creating_link"),
                    text: String.format(i18next.t("link_creating_error"), el.Source.PropertyPath, el.Source.ItemId, el.Source.el ? el.Source.el._elname : ""),
                });
            }
        }
        const valCache = {};
        const sortUpLinks = upLinks.sort((a, b) => {
            if (a.type === "server" && a.type > b.type) {
                return -1;
            } else {
                return 1;
            }
        });
        sortUpLinks.forEach(el => {
            if (el.target.Type === "trend") {
                if (el.target.PropertyPath.indexOf("DataSource") > -1)
                    el.target.el.onStringPenChanged(el.target.PropertyPath, el.value);
                else
                    el.target.el.changePenAttribute(el.target.PropertyPath, this._convert(el.target.el, el.value, el.target.DataType, el.target.ItemId));
            } else {
                if (!el.sourceP || el.sourceP.indexOf("PanelDataSource") === -1) {
                    let val = null;
                    if (typeof valCache[`${el.sourceId}/${el.sourceP}`] !== "undefined") {
                        val = valCache[`${el.sourceId}/${el.sourceP}`];
                    }

                    if (val == null && el.type === "client") {
                        let srcEl = this.getEl(msWin, node, el.sourceId, el.Type);
                        if (!srcEl && msWin.typeid === el.sourceId)
                            srcEl = msWin;

                        if (srcEl) {
                            const sp = el.sourceP.split(".");
                            val = srcEl;
                            for (let i = 0; i < sp.length && val != null; i++) {
                                val = typeof val[sp[i]] === "undefined"
                                    ? val[sp[i].toLowerCase()]
                                    : val[sp[i]];
                            }
                        }
                    }
                    if (val == null && el.value != null && typeof(el.value) === "string" && el.datatype !== "STRING")
                        val = this._convertParamFromString(el.value, el.datatype, `${el.target.ItemId}/${el.target.PropertyPath}`);
                    if (val == null) val = el.value;
                    const newVal = this._operation(el.target, val, el.datatype, null, el.sourceId, null, {dontSendToServer : true});
                    valCache[`${el.target.ItemId}/${el.target.PropertyPath}`] = newVal;
                }
            }
        });
        return resultItems;
    }

    getEl(msWin, node, ItemId, type) {
        if (type === "server" || type === "clientglobal")
            return null;

        if (msWin.id === ItemId) {
            return msWin;
        }
        if (node) {
            const el = node.id == ItemId
                ? node
                : node.querySelector(`[id='${ItemId}']`) || node.closest(`[id='${ItemId}']`);;
            if (el != null)
                return el;
        }
        const el = msWin.querySelector(`[id='${ItemId}']`);
        if (el != null)
            return el;
        return null;
    }

    SetAction(el, msWin, node) {
        const types = this.Type.type;
        let control;

        if (msWin.id === el.ItemId) {
            control = msWin;
        } else {
            if (node)
                control = node.id == el.ItemId ? node : node.querySelector(`[id='${el.ItemId}']`);
            if (control == null)
                control = msWin.querySelector(`[id='${el.ItemId}']`);
        }

        if (control == null && msWin.typeid === el.ItemId) {
            control = msWin;
        }
        if (control != null && !control.actions[el.ActionId]) {
            let cTypes =
                this.getActionTypes(types, msWin.id, el.ActionId) ||
                this.getActionTypes(types, msWin.typeid, el.ActionId);
            if (cTypes) {
                cTypes = JSON.parse(JSON.stringify(cTypes));
                control.actions[el.ActionId] = new ActionFactory(
                    cTypes.actions[el.ActionId],
                    control
                );
            }
        }
        return control;
    }

    getActionTypes(types, id, actionId) {
        if (
            typeof types[id] !== "undefined" &&
            typeof types[id].actions !== "undefined" &&
            typeof types[id].actions[actionId] !== "undefined"
        ) {
            return types[id];
        } else return false;
    }

    UpdateAction(control, element, sValue) {
        let elActions = control.actions[element.ActionId];
        if (typeof elActions !== "undefined") {
            if (typeof elActions[element.PropertyPath] !== "undefined") {
                if (
                    typeof elActions[element.PropertyPath].value !== "undefined"
                ) {
                    elActions[element.PropertyPath].value = sValue;
                } else {
                    elActions[element.PropertyPath] = sValue;
                }
            } else if (elActions.parameters) {
                if (
                    typeof elActions.parameters[element.PropertyPath] !==
                    "undefined"
                ) {
                    elActions.parameters[element.PropertyPath] = sValue;
                    elActions.UpdateParameters(element.PropertyPath, sValue);
                }
            }
        }
    }

    StartWatch() {
        if (this.started) return;
        this.started = true;

        let options = {
            methodType: C.intervalStart,
            method: M.PublishData,
            interval: _globalParams.UpdateInterval,
        };
        this.ServerAdapter.sendRequest(options, data => {
            if (data.recs) {
                data.recs.forEach(rec => {
                    this.LinkUp(rec);
                });
            }
        });

        this.unsubscribeOldItemsTimer = setInterval(
            this.unsubscribeOldItems.bind(this),
            10000
        );
    }

    unsubscribeOldItems()
    {
        const delay = window._globalParams?.UnsubscribeOldItems ?? 600000;
        const itemsToDel = [];
        for (var source of this.Observer.values()) {
            if (source.UseCount === 0 && Date.now() - source.LastRemoveTime > delay)
                itemsToDel.push(source);
        };
        if (itemsToDel.length > 0) {
            this.DeleteMonitoredDataItems(itemsToDel.map(source => source.monitoredItemId));
            itemsToDel.forEach(source => {
                  this.Observer.delete(source.ObserverIndex);
                  delete this.Links.Items[source.LinkKey];
                  this.ItemsContainer.delete(source.ObserverIndex);
            });
        }
    }

    StopWatch() {
        if (!this.started) return;
        this.started = false;

       clearInterval(this.unsubscribeOldItemsTimer);

        let options = {
            methodType: C.intervalStop,
            method: M.PublishData,
        };
        this.ServerAdapter.sendRequest(options);
    }

    async reSubscribe() {
        //const item = {
        //    type: 'error',
        //    time: new Date().toLocaleString(),
        //    title: 'Передан недействительный код подписки',
        //    text: '2150105088'
        //};
        //$ns.add(item);
        this.StopWatch();
        return await this.CreateDataSubscription()
            .then(response =>
                this.CreateMonitoredDataItems(
                    [...this.ItemsContainer.values()],
                    response.subscriptionId
                )
            )
            .then(() => this.onRestore());
    }

    onRestore() {
        this.StartWatch();
        //        const item = {
        //            type: 'info',
        //            time: new Date().toLocaleString(),
        //            title: 'Подписка восстановлена'
        //            text: '2150105088 resolved'
        //    };
        //    $ns.add(item);
    }

    _WriteData(pack) {
        let options = {
            pack,
            method: M.WriteData,
            methodType: C.single,
        };
        this.ServerAdapter.sendRequest(options, (data) => {
            if (data.recs?.length > 0 && data.recs[0].statusCode === 0x801F0000) {
                $ns.add({
                    type: "error",
                    time: new Date().toLocaleString(),
                    title: i18next.t("write_data_error"),
                    text: String.format(i18next.t("write_data_error_rights"), pack.recs[0].itemId),
                });
            }
        });
    }

    _getRawValue(v) {
        if (v && typeof v === "object" && typeof v.value === "object" && v.dataType)
            return v.value;
        return v;
    }
    /**
     * Связывание параметров
     * @param {HTMLElement} element контекст
     * @param {any} linkUp коллбек
     * @param {any} value значение
     * @param {any} attrName название атрибута
     * @param {any} itemIndex номер
     * @param {string} operation операция
     * @param {bool} isCondition (при вызове из _LinkCreator = false, чтобы не срабатывал триггер при старте)
     * @param {object} callbackData 
     */
    LinkUp(element, linkUp, value, attrName, itemIndex, operation, callbackData, isCondition = true) {
        let triggers = [];
        let links = null;
        let sId;

        if (typeof callbackData == "boolean")
            callbackData = {forced : callbackData}; //для совместимости со старыми вызовами
        if (linkUp) {
            if (linkUp.screentask && linkUp.msWin && linkUp.msWin.isdisconnected) {
                return false;
            }
            if (linkUp.Source.Type == "server" || linkUp.Source.Type == "screentask") {
                callbackData ??= {};
                callbackData.link = true;
            }
            links = { value: linkUp };
        } else if (typeof value !== "undefined") {
            links = this.Links.Items[element];
        } else {
            if (!this.Observer.has(element.clientHandle))
                return;
            const item = this.Observer.get(element.clientHandle);
            if (item.isBlocked)
                return;
            if (item.value && item.Type !== "server" && item.value == element.value)
                return;
            item.value = element.value;
            sId = item.PropertyPath
                ? item.ItemId + "/" + item.DataType + "/" + item.PropertyPath
                : item.ItemId + "/" + item.DataType;
            links = this.Links.Items[sId];
            if (!this.ServerParam[sId]) {
                this.ServerParam[sId] = item;
            } else {
                this.ServerParam[sId].value = item.value;
            }
            value = element.value;

            if (item.Type == "server" || item.Type == "screentask") {
                callbackData ??= {};
                callbackData.link = true;
            }
        }
        if (links) {
            const res = [];
            for (let key in links) {
                let forRemove = false;
                for (let index = 0; index < links[key].Targets.length; index++) {
                    const el = links[key].Targets[index];
                    try {
                        const stackKey = `${links[key].Source.ItemId}/${links[key].Targets[index].ItemId}`;
                        if (window.stack.has(stackKey)) {
                            window.stack.get(stackKey).c++;
                        } else {
                            window.stack.set(stackKey, {
                                s: links[key].Source.ItemId,
                                t: links[key].Targets[index].ItemId,
                                c: 1,
                            });
                        }
                        if (operation) {
                            for (var prop in operation) {
                                el[prop] = operation[prop];
                            }
                        }
                        if (((el.el && !el.el.isConnected) || el.el === null) && el.els === undefined) {
                            delete links[key].Targets[index].el;
                            delete links[key].Targets[index];
                            forRemove = true;
                            continue;
                        }
                        const propptr = links[key].Source.PropertyPath.split(".");
                        if (attrName && attrName != links[key].Source.PropertyPath.toLowerCase() && propptr.length === 1) {
                            break;
                        }
                        switch (el.Type) {
                            case "clientglobal":
                                const sVal = this._convert(el, value, el.DataType);
                                const oldVal = this.clientGlobalParamValues.get(el.PropertyPath);
                                if (oldVal === sVal) {
                                    break;
                                }
                                this.clientGlobalParamValues.set(el.PropertyPath, sVal);
                                let clientGlobal = this.clientGlobalParamCallBacks.get(el.PropertyPath);
                                if (clientGlobal)                             
                                    clientGlobal.forEach((wins) => wins.forEach((callback) => callback(sVal, null, null, null, false, isCondition)));     
                                break;                        
                            case "screentask":
                                this.CreateTaskManager();
                                this.TaskManager.tasks.generatedTask.postMessage(el,this._getRawValue(this._convert(el, value, links[key].Source.DataType, links[key].Source.ItemId)));
                                break;
                            case "svg":
                            case "client": {
                                const target = this.GetComponent(el, itemIndex, false);
                                if (!target)
                                    continue;
                                const propertyPath = el.PropertyPath.split(":");
                                itemIndex = typeof itemIndex === "undefined" ? el.ItemIndex : itemIndex;
                                let srcVal = value;
                                if (el.SourcePath) {
                                    srcVal = this._getRawValue(value);

                                    const sp = el.SourcePath.split(".");
                                    if (sp.length > 1) {
                                        for (let i = 1; i < sp.length; i++) {
                                            if (srcVal === undefined) {
                                                // проверку нужно ставить здесь, поскольку srcVal перезаписывается внутри цикла
                                                break;
                                            }
                                            if (itemIndex !== undefined && srcVal[itemIndex]) {
                                                srcVal = typeof srcVal[itemIndex][sp[i]] === "undefined"
                                                        ? srcVal[itemIndex][sp[i].toLowerCase()]
                                                        : srcVal[itemIndex][sp[i]];
                                            } else {
                                                srcVal = typeof srcVal[sp[i]] === "undefined"
                                                        ? srcVal[sp[i].toLowerCase()]
                                                        : srcVal[sp[i]];
                                            }
                                        }
                                    }
                                    if (srcVal === undefined)
                                        break;
                                }
                                const DataType = el.SourceDataType != undefined
                                        ? el.SourceDataType
                                        : links[key].Source.DataType;

                                if (target && target.addDataSource) {
                                    if (el.PropertyPath.indexOf("DataSource") !== -1) {
                                        const params = [
                                            {
                                                taskId: el.TaskNumber || 0,
                                                itemId: 0,
                                                path: value,
                                                type: el.DataType,
                                                dataSourceId: "MPLCDataSource",
                                                usesCounts: 1,
                                            },
                                            el.PropertyPath,
                                        ];
                                        if (target.nodeName === "MS-TREND")
                                            params.push(true);
                                        target.addDataSource(...params);
                                        target.onStringPenChanged(el.PropertyPath, value);
                                    } else {
                                        if (el.PropertyPath.indexOf(".") != -1) {
                                            target.changePenAttribute(el.PropertyPath, this._convert(el, value, DataType, links[key].Source.ItemId));
                                        }
                                    }
                                }
                                if (propertyPath.length > 1 && (propertyPath[0] !== "svg" || target._main)) {
                                    if (links[key].Source.ItemId == target.id && target.setSvgParams) {
                                        target.setSvgParams(el.PropertyPath, srcVal);
                                    } else {
                                        const pr = propertyPath[0] === "svg"
                                                ? [...propertyPath, links[key].Source.PropertyPath].slice(1)
                                                : propertyPath.slice(1);
                                        // const pr = propertyPath.slice(1);
                                        target[propertyPath[0].toLowerCase()](pr, this._convert(el, srcVal, DataType, links[key].Source.ItemId));
                                    }
                                } else if (propptr.length > 1 && value && value.value && value.value[propptr[1]]) {
                                    const pth = el.SourcePath.split(".")[1];
                                    const result = this._operation(el, value.value[pth], DataType, itemIndex, links[key].Source.ItemId, attrName, callbackData);
                                    if (result == null && this.GetComponent(el, itemIndex, true) == null) {
                                        delete links[key].Targets[index];
                                        forRemove = true;
                                    }
                                } else {
                                    const result = this._operation(el, srcVal, DataType, itemIndex, links[key].Source.ItemId, attrName, callbackData);
                                    if (result == null && this.GetComponent(el, itemIndex, true) == null) {
                                        delete links[key].Targets[index];
                                        forRemove = true;
                                        // continue;
                                    }
                                }
                                break;
                            }
                            case "server": {
                                if (callbackData?.dontSendToServer)
                                    break;
                                let servItem = el.ItemId;
                                servItem = el.PropertyPath
                                    ? el.ItemId + "/" + el.DataType + "/" + el.PropertyPath
                                    : el.ItemId + "/" + el.DataType;
                                if (el.HasBackward && (typeof this.ServerParam[servItem] === "undefined" || typeof this.ServerParam[servItem].value === "undefined"))
                                    break;
                                // if (el.HasBackward && !el.Inited) { el.Inited = true; break; }
                                let refVal = value;
                                if (el.SourcePath && el.SourcePath.includes(".")) {
                                    const path = el.SourcePath.split(".");
                                    path.splice(0, 1);
                                    while (path.length > 0) {
                                        refVal = refVal[path[0]];
                                        path.splice(0, 1);
                                    }
                                }
                                const setValue = this._convert(el, refVal, links[key].Source.DataType, links[key].Source.ItemId);

                                if (setValue != null && typeof setValue === "object" && setValue.type === "customConvertError")
                                    break;
                                if (typeof this.ServerParam[servItem] === "undefined") {
                                    this.ServerParam[servItem] = el;
                                }
                                let packValue = this._getRawValue(setValue);
                                const comp = callbackData?.forced
                                    ? false
                                    : this.CompareValue(this.ServerParam[servItem].DataType, this.ServerParam[servItem].value, packValue);
                                if (this.ServerParam[servItem] && comp && el.Operation === "move") 
                                    break;
                                
                                const pack = {
                                    taskId: el.TaskNumber || 0,
                                    dataSourceId: "MPLCDataSource",
                                    itemId: Number(el.ItemId),
                                    path: el.PropertyPath,
                                    operation: el.Operation,
                                    parameter: el.Parameter,
                                    type: el.DataType,
                                    usesCounts: 1,
                                    value: packValue,
                                };
                                this.ServerParam[servItem].value = this.CloneValue(this.ServerParam[servItem].DataType, packValue);
                                this.sendTimestamp++;
                                res.push(pack);
                                break;
                            }
                            case "action": {
                                let control = this.GetComponent(el, itemIndex, false);
                                if (!control)
                                    break;
                                let _refVal = value;
                                if (el.SourcePath && el.SourcePath.includes(".")) {
                                    const path = el.SourcePath.split(".");
                                    path.splice(0, 1);
                                    while (path.length > 0) {
                                        _refVal = _refVal[path[0]];
                                        path.splice(0, 1);
                                    }
                                    if (_refVal === undefined)
                                        break;
                                }
                                const sourceDateType = typeof _refVal === "string" && _refVal !== ""
                                        ? "STRING"
                                        : links[key].Source.DataType;
                                const sValue = this._convert(el, _refVal, sourceDateType, links[key].Source.ItemId);
                                if (!control.actions[el.ActionId]) {
                                    this.createAction(control, el.ActionId);
                                }
                                this.UpdateAction(control, el, sValue);

                                if (control.parentElement.nodeName === "MS-PSTACK") {
                                    for (let child of control.parentElement.children) {
                                        if (!child.actions[el.ActionId]) {
                                            this.createAction(child, el.ActionId);
                                            control.parentElement.addAdditionalAction(child._ItemIndex, el);                                      
                                        }
                                        control.parentElement.updateAdditionalAction(child, sValue);   
                                    }                             
                                }
                                break;
                            }
                            case "trend": {
                                const target = this.GetComponent(el, itemIndex, false);
                                if (target) {
                                    if (el.PropertyPath.indexOf("DataSource") === -1)
                                        target.changePenAttribute(el.PropertyPath, this._convert(el, value, links[key].Source.DataType, links[key].Source.ItemId));
                                    else if (links[key].Source.DataType === "STRING" || (linkUp && linkUp.Source.DataType === "STRING") || target.nodeName === "MS-CHART") {
                                        //только стринговое перо будет меняться отсюда
                                        if (value)
                                            target.onStringPenChanged(el.PropertyPath, value);
                                    }
                                } else {
                                    delete links[key].Targets[index];
                                    forRemove = true;
                                }
                                break;
                            }
                            case "trigger":
                                // this.setTrigger(el, value, links[key].Source.DataType);
                                const dataType = links[key].Source.PropertyPath && el.SourceDataType
                                    ? el.SourceDataType
                                    : links[key].Source.DataType;
                                triggers.push({
                                    el: el,
                                    value: value,
                                    dt: dataType,
                                });
                                break;
                        }
                        if (window.stack.get(stackKey).c > 1) {
                            window.stack.get(stackKey).c--;
                        } else {
                            window.stack.delete(stackKey);
                        }
                    } catch (e) {
                        console.error(e);
                        $ns.add({
                            type: "error",
                            time: new Date().toLocaleString(),
                            title: i18next.t("title_error_setting_link"),
                            text: String.format(i18next.t("link_setting_error"), value, links[key].Source.ItemId, el.PropertyPath, el.ItemId, el.el ? el.el._elname : ""),
                        });
                    }
                }
                // удаление не действительных связей
                if (forRemove) {
                    let i = links[key].Targets.length;
                    while (i--) {
                        if (links[key].Targets[i] === undefined) {
                            links[key].Targets.splice(i, 1);
                        }
                    }
                    if (links[key].Targets.length === 0) {
                        const clientHandle = element?.clientHandle;
                        if (clientHandle && this.Observer.has(clientHandle)) {
                            this.Observer.get(clientHandle).LastRemoveTime = Date.now()
                            this.Observer.get(clientHandle).UseCount = 0
                        }
                    }
                }
            }
            if (triggers.length > 0) {
                for (let i = 0; i < triggers.length; i++) {
                    const el = triggers[i];
                    try {
                        this.setTrigger(el.el, el.value, el.dt, isCondition);
                    } catch (e) {
                        // todo: Нужно иметь в виду, что триггеры могут иметь вложенные условия, и если упадёт ошибка во вложенном условии, то пользователю, всё равно будет выведен id внешнего условия.
                        // Также ошибка может упасть не только в логике настройки триггера (this.setTrigger, например, при конвертации), но и внутри вызова действия самого триггера CallActionManager(),
                        // Мы также не узнаем об этом - пользователю на экран будет выведена информация только о внешнем триггере    
                        console.error(e);
                        $ns.add({
                            type: "error",
                            time: new Date().toLocaleString(),
                            title: i18next.t("title_error_setting_trigger"),
                            text: String.format(i18next.t("trigger_setting_error"), el.value, el.el.ConditionId, el.el.ParameterId, el.el.el?.id, el.el.el?._elname),
                        });
                    }
                }
                triggers = null;
            }
            if (res.length > 0) {
                this._WriteData({ recs: res });
            }
            return true;
        }
    }

    /**
     * Создать действие
     * @param {HTMLElement} control элемент-владелец действия
     * @param {number} ActionId ID действия
     */
    createAction(control, ActionId) {
        const types = this.Type.type;
        let msWin = control.msWin;
        if (!msWin) {
            msWin = control;
            while (msWin.nodeName !== "MS-WINDOW") {
                msWin = msWin.parentElement;
            }
        }
        while (msWin) {
            let act =
                types[msWin.id] && types[msWin.id].actions[ActionId]
                    ? types[msWin.id].actions[ActionId]
                    : null;
            if (!act)
                act =
                    types[msWin.typeid] && types[msWin.typeid].actions[ActionId]
                        ? types[msWin.typeid].actions[ActionId]
                        : null;
            if (!act) {
                msWin = msWin.parentElement;
                continue;
            }
            act = JSON.parse(JSON.stringify(act));
            control.actions[ActionId] = new ActionFactory(act, control);
            return;
        }
        const item = {
            type: "error",
            time: new Date().toLocaleString(),
            title: i18next.t("title_action_not_found"),
            text:
                String.format(i18next.t("action_not_found_error"), ActionId, control.id),
        };
        $ns.add(item);
    }

    /**
     * Сравнение двух значений
     * @param {any} val1 первое значение
     * @param {any} val2 второе значение
     * @return {bool} результат сравнения
     */
    CompareValue(dataType, val1, val2) {
        let ret;
        switch (DataTypes.dataTypes[dataType].DataType) {
            case "StructureType":
            case "ArrayType":
                ret = JSON.stringify(val1) == JSON.stringify(val2);
                break;

            default:
                ret = val1 == val2;
        }
        return ret;
    }
    CloneValue(dataType, val) {
        let ret;
        switch (DataTypes.dataTypes[dataType].DataType) {
            case "StructureType":
            case "ArrayType":
                ret = JSON.parse(JSON.stringify(val));
                break;

            default:
                ret = val;
        }
        return ret;
    }
    /**
     * Получить элемент по связи
     * @param {any} item связь
     * @return {HTMLElement} элемент
     */
    GetComponent(item, itemIndex, tryFind) {
        if (
            item.els !== undefined &&
            itemIndex !== undefined &&
            item.els[itemIndex] !== undefined
        )
            return item.els[itemIndex];

        if (!item.el && tryFind) {
            item.el = document.getElementById(item.ItemId);
            if (!item.el) {
                return;
            }
            return item.el;
        }
        return item.el;
    }
    /**
     * Получить действие по связи
     * @param {any} item связь
     * @return {HTMLElement} действие
     */
    GetAction(item) {
        return document.querySelector(`[id='${item.ItemId}']`).actions[
            item.ActionId
        ];
    }

    _convert(el, value, sourceType, sourceId) {
        return Converter.convert(el, value, sourceType, sourceId);
    }

    _convertParamFromString(value, type, paramId) {
        if (!value)
            return null;
        const res = Converter["STRING"](value, type);
        if (
            res != null &&
            typeof res === "object" &&
            res.type === "customConvertError"
        ) {
            if (paramId) res.err.text = `id="${paramId}":<br> ${res.err.text}`;
            $ns.add(res.err);
            return null;
        }

        return res;
    }

    setTrigger(target, value, DataType, isСondition = true) {
        if (_globalParams.Options && _globalParams.Options.split(",").includes("OldTriggerLogic")) {
            this.callOldTriggerLogic(target, value, DataType, isСondition);
            return;
        }
        if (target.el && target.el.windowTriggers) {
            const windowTriggers = target.el.windowTriggers
            const currentTriggerId = windowTriggers[target.ConditionId].TriggerId
            let res = false;
            let changeConditionTriggered = false;
            let prevValue;

            for (let { TriggerId, ConditionSet } of Object.values(windowTriggers)) {
                if (TriggerId !== currentTriggerId || !ConditionSet?.length) 
                    continue;
                let trgSensCount = 0;

                ConditionSet.forEach(
                    e => {
                        if (e.ConditionFields.hasOwnProperty(target.ParameterId)) {
                            if (e.ConditionFields.value != target.ParameterId && typeof e.ConditionFields[e.ConditionFields.value] === "string" && DataType !== "STRING") {
                                e.ConditionFields[e.ConditionFields.value] =
                                    this._convertParamFromString(
                                        e.ConditionFields[e.ConditionFields.value],
                                        DataType,
                                        target.ParameterId
                                    );
                            }
                            if (e.ConditionFields.operand != target.ParameterId && typeof e.ConditionFields[e.ConditionFields.operand] === "string" && DataType !== "STRING") {
                                e.ConditionFields[e.ConditionFields.operand] =
                                    this._convertParamFromString(
                                        e.ConditionFields[e.ConditionFields.operand],
                                        DataType,
                                        target.ParameterId
                                    );
                            }
                            prevValue = e.ConditionFields[target.ParameterId];
                            e.ConditionFields[target.ParameterId] = value;
                        }

                        if (isСondition) {
                            const { operand, val } = convertToTypesForCompare(e.ConditionFields[e.ConditionFields.operand], e.ConditionFields[e.ConditionFields.value])
                            if (operand == null || (e.ConditionFields.comparer !== "Change" && val == null))
                                return;
                            switch (e.ConditionFields.comparer) {
                                case "Equal":
                                    trgSensCount += Number(operand == val);
                                    break;
                                case "NotEqual":
                                    trgSensCount += Number(operand != val);
                                    break;
                                case "More":
                                    trgSensCount += Number(operand > val);
                                    break;
                                case "MoreEqual":
                                    trgSensCount += Number(operand >= val);
                                    break;
                                case "Less":
                                    trgSensCount += Number(operand < val);
                                    break;
                                case "LessEqual":
                                    trgSensCount += Number(operand <= val);
                                    break;
                                case "Change": {
                                    if (windowTriggers.TriggerActivity?.[currentTriggerId] != null && typeof prevValue !== "undefined" && prevValue != value) {
                                        // Триггер не должен срабатывать, если до этого значения не было
                                        trgSensCount += 1;
                                        changeConditionTriggered = true;
                                    }
                                    break;
                                }
                                case "Contains":
                                    if (operand.toString().indexOf(value.toString()) > 0) {
                                        trgSensCount++;
                                    }
                                    break;
                            }
                        }
                    }
                );
                if (trgSensCount === ConditionSet.length)
                    res = true;
            }

            if (!windowTriggers.TriggerActivity) {
                windowTriggers.TriggerActivity = {};
            }
            if (res && (changeConditionTriggered || windowTriggers.TriggerActivity[currentTriggerId] !== true)) {
                const ta = windowTriggers[target.ConditionId].TriggerActions.split(",");
                const targetel = target.el;
                    Promise.resolve().then(() => {
                        targetel.CallActionManager(ta, { currentTarget: targetel });
                    });
            }
            windowTriggers.TriggerActivity[currentTriggerId] = res;
        }
    }

    callOldTriggerLogic(target, value, DataType, isСondition) {
        if (target.el && target.el.windowTriggers) {
            let trgSensCount = 0;
            target.el.windowTriggers[target.ConditionId].ConditionSet.forEach(
                e => {
                    if (e.ConditionFields.hasOwnProperty(target.ParameterId)) {
                        if (e.ConditionFields.value != target.ParameterId && typeof e.ConditionFields[e.ConditionFields.value] === "string" && DataType !== "STRING") {
                            e.ConditionFields[e.ConditionFields.value] =
                                this._convertParamFromString(
                                    e.ConditionFields[e.ConditionFields.value],
                                    DataType,
                                    target.ParameterId
                                );
                        }
                        if (e.ConditionFields.operand != target.ParameterId && typeof e.ConditionFields[e.ConditionFields.operand] === "string" && DataType !== "STRING") {
                            e.ConditionFields[e.ConditionFields.operand] =
                                this._convertParamFromString(
                                    e.ConditionFields[e.ConditionFields.operand],
                                    DataType,
                                    target.ParameterId
                                );
                        }
                        e.ConditionFields[target.ParameterId] = value;
                    }

                    const operand =
                        e.ConditionFields[e.ConditionFields.operand];
                    const val = e.ConditionFields[e.ConditionFields.value];
                    if (isСondition) {
                        switch (e.ConditionFields.comparer) {
                            case "Equal":
                                trgSensCount += Number(operand == val);
                                break;
                            case "NotEqual":
                                trgSensCount += Number(operand != val);
                                break;
                            case "More":
                                trgSensCount += Number(operand > val);
                                break;
                            case "MoreEqual":
                                trgSensCount += Number(operand >= val);
                                break;
                            case "Less":
                                trgSensCount += Number(operand < val);
                                break;
                            case "LessEqual":
                                trgSensCount += Number(operand <= val);
                                break;
                            case "Contains":
                                if (
                                    operand
                                        .toString()
                                        .indexOf(value.toString()) > 0
                                ) {
                                    trgSensCount++;
                                }
                                break;
                        }
                    }
                }
            );
            if (!target.el.windowTriggers.TriggerActivity) {
                target.el.windowTriggers.TriggerActivity = {};
            }
            const tId = target.el.windowTriggers[target.ConditionId].TriggerId;
            const res =
                trgSensCount ==
                target.el.windowTriggers[target.ConditionId].ConditionSet
                    .length;
            if (res && target.el.windowTriggers.TriggerActivity[tId] !== true) {
                const ta =
                    target.el.windowTriggers[
                        target.ConditionId
                    ].TriggerActions.split(",");
                const targetel = target.el;
                Promise.resolve().then(() => {
                    targetel.CallActionManager(ta, { currentTarget: targetel });
                });
            }
            target.el.windowTriggers.TriggerActivity[tId] = res;
        }
    }

    /**
     * Выполнение операции
     * @param {element} el элемент
     * @param {any} value значение
     * @param {string} sourceType тип данных
     * @param {number} itemIndex индекс (для элемента массива)
     * @param {number} sourceId ID источника
     * @return {number} успешность операции
     */
    _operation(el, value, sourceType, itemIndex, sourceId, attrName, callbackData) {
        try {
            const target = this.GetComponent(el, itemIndex, true);
            let val;
            if (!target) {
                $ns.add({
                    type: "error",
                    time: new Date().toLocaleString(),
                    title: i18next.t("title_operation_error"),
                    text: String.format(i18next.t("element_id_not_found"), el.ItemId),
                });
                return null;
            }
            switch (typeof value) {
                case "object":
                    val =
                        value &&
                            (typeof value.dataType === "undefined" ||
                                typeof value.value === "undefined")
                            ? {
                                dataType: el.DataType,
                                value: JSON.parse(JSON.stringify(value)),
                            }
                            : value;
                    break;
                default:
                    val = value;
                    break;
            }
            const sVal = this._convert(el, val, sourceType, sourceId);
            if (
                sVal != null &&
                typeof sVal === "object" &&
                sVal.type === "customConvertError"
            )
                return null;

            const propertyPath = convertPropertyPath(el.PropertyPath);
            const prevVal = target[propertyPath];
            switch (el.Operation) {
                case "move":
                    target.SetParameter(
                        propertyPath,
                        sVal,
                        true,
                        itemIndex,
                        null,
                        attrName,
                        callbackData
                    );
                    return sVal;
                case "add":
                    target.SetParameter(
                        propertyPath,
                        +prevVal + sVal,
                        true,
                        itemIndex,
                        null,
                        attrName,
                        callbackData
                    );
                    return +prevVal + sVal;
                case "sub":
                    target.SetParameter(
                        propertyPath,
                        +prevVal - sVal,
                        true,
                        itemIndex,
                        null,
                        attrName,
                        callbackData
                    );
                    return +prevVal - sVal;
                case "mul":
                    target.SetParameter(
                        propertyPath,
                        +prevVal * sVal,
                        true,
                        itemIndex,
                        null,
                        attrName,
                        callbackData
                    );
                    return +prevVal * sVal;
                case "div":
                    target.SetParameter(
                        propertyPath,
                        +prevVal / sVal,
                        true,
                        itemIndex,
                        null,
                        attrName,
                        callbackData
                    );
                    return +prevVal / sVal;
                case "impulse":
                    let delay = Number(el.Parameter); // такт задачи экрана в будущем
                    if (isNaN(delay) || delay <= 0) delay = 500;
                    target.SetParameter(propertyPath, true, true, itemIndex);
                    if (!target.impulseTimeouts) {
                        target.impulseTimeouts = new Set();
                    }
                    const impulseTimeoutId = setTimeout(
                        () => {
                            target.SetParameter(
                                propertyPath,
                                false,
                                true,
                                itemIndex,
                                null,
                                attrName,
                                callbackData
                            );
                            target.impulseTimeouts.delete(impulseTimeoutId);
                        },
                        delay
                    )
                    target.impulseTimeouts.add(impulseTimeoutId);
                    break;
                default:
                    target.SetParameter(
                        propertyPath,
                        sVal,
                        true,
                        itemIndex,
                        null,
                        attrName,
                        callbackData
                    );
                    return sVal;
            }
            return null;
        } catch (e) {
            $ns.add({
                type: "error",
                time: new Date().toLocaleString(),
                title: i18next.t("title_error_setting_value"),
                text: String.format(i18next.t("value_setting_error"), value, el.PropertyPath, el.ItemId, el.el ? el.el._elname : ""),
            });
        } 
    }
}
